import { createReducer, on } from '@ngrx/store'
import { MAX_NOTIFICATION_CHUNK_SIZE } from '@platform-lib/notification/notification.model'
import { notificationEntryAdapter } from '@platform-lib/notification/redux/notification.adapter'
import * as notificationActions from './notification.actions'
import {
    NotificationState,
    initialNotificationState,
} from './notification.state'

export const notificationReducer = createReducer(
    initialNotificationState,

    // count loading
    on(notificationActions.loadCountSuccess, (state, { response }) => ({
        ...state,
        // without the check and fallback,some testcafe test fail
        // when the notification count endpoint isn't mocked
        count:
            response && response.hasOwnProperty('unreadCount')
                ? response?.unreadCount || 0
                : state.count,
    })),

    // entry list loading
    on(notificationActions.loadEntries, (state) => ({
        ...state,
        overlayEntriesLoading: true,
        overlayEntriesError: null,
    })),

    on(
        notificationActions.loadOverlayNotificationsSuccess,
        (state, { response }) => ({
            ...state,
            overlayEntries: notificationEntryAdapter.setAll(
                response.notifications,
                state.overlayEntries
            ),
            overlayEntriesLoading: false,
            overlayEntriesLoadingError: null,
        })
    ),

    on(
        notificationActions.loadOverlayNotificationsError,
        (state, { error }) =>
            ({
                ...state,
                overlayEntriesLoading: false,
                overlayEntriesError: error,
            }) as NotificationState
    ),

    on(notificationActions.loadPageNotifications, (state, request) => ({
        ...state,
        pageLoading: true,
        pageLoadingError: null,
        pageEntries:
            request.offset === 0
                ? notificationEntryAdapter.removeAll(state.pageEntries)
                : state.pageEntries,
    })),

    on(
        notificationActions.loadPageNotificationsSuccess,
        (state, { response }) => ({
            ...state,
            allRead: response.allRead,
            pageEntries: notificationEntryAdapter.upsertMany(
                response.notifications,
                state.pageEntries
            ),
            pageEntriesAvailable: response.hasMoreNotifications,
            pageLoading: false,
            pageLoadingError: null,
            pageEntriesLoaded:
                state.pageEntriesLoaded + MAX_NOTIFICATION_CHUNK_SIZE,
            selectableUseCases: response.useCases,
        })
    ),

    on(notificationActions.loadPageNotificationsError, (state, { error }) => ({
        ...state,
        pageLoading: false,
        pageLoadingError: error,
    })),

    // filtering
    on(notificationActions.setFilterValues, (state, { filterValues }) => ({
        ...state,
        pageEntriesLoaded: 0,
        filterValues,
    })),

    // remove entries
    on(notificationActions.removeEntries, (state, { request }) => ({
        ...state,
        removeEntriesParams: { ...request },
    })),

    on(notificationActions.removeEntriesSuccess, (state, { response }) => ({
        ...state,
        overlayEntries: notificationEntryAdapter.removeMany(
            response.notificationIds,
            state.overlayEntries
        ),
        pageEntries: notificationEntryAdapter.removeMany(
            response.notificationIds,
            state.pageEntries
        ),
        removeEntriesParams: null,
    })),

    on(notificationActions.removeEntriesError, (state) => ({
        ...state,
        removeEntriesParams: null,
    })),

    on(notificationActions.setIsReadSuccess, (state, { response }) => ({
        ...state,
        overlayEntries: notificationEntryAdapter.updateMany(
            response.notificationIds.map((id) => ({
                id,
                changes: { isRead: true },
            })),
            state.overlayEntries
        ),
        pageEntries: notificationEntryAdapter.updateMany(
            response.notificationIds.map((id) => ({
                id,
                changes: { isRead: true },
            })),
            state.pageEntries
        ),
    })),

    on(notificationActions.setAllAsRead, (state) => ({
        ...state,
        setAllAsReadLoading: true,
    })),

    on(notificationActions.setAllAsReadError, (state) => ({
        ...state,
        setAllAsReadLoading: false,
    })),

    on(notificationActions.setAllAsReadSuccess, (state, { response }) => ({
        ...state,
        allRead: true,
        setAllAsReadLoading: false,
        overlayEntries: notificationEntryAdapter.updateMany(
            state.overlayEntries.ids.map((id) => ({
                id,
                changes: { isRead: true },
            })),
            state.overlayEntries
        ),
        pageEntries: notificationEntryAdapter.updateMany(
            state.pageEntries.ids.map((id) => ({
                id,
                changes: { isRead: true },
            })),
            state.pageEntries
        ),
    })),

    on(notificationActions.reset, (state) => ({
        ...initialNotificationState,
    }))
)
